<template>
  <div class="commentBox d-flex flex-column">
    <div class="d-flex justify-space-between align-center mb-2">
      <UserAvatar :disableOpenLink="true" :user="user" :hideRoles="true"></UserAvatar>
    </div>
    
    <div class="add-comment-mode">
      <v-tiptap
        v-model="newComment"
        :toolbar="['bold', 'italic', 'underline', '|', 'bulletList', 'orderedList']"
        attach
        :mention="true"
        :mentionItems="mentionItems"
        class="tiptap-section-card editable"
        placeholder="Add your comment..." />
      <div class="d-flex justify-end mt-2 gap-2">
        <v-btn
          small
          outlined
          @click="$emit('close-adding')"
          :disabled="updateLoading">
          Cancel
        </v-btn>
        <v-btn
          small
          color="primary"
          @click="postComment"
          :loading="updateLoading"
          :disabled="!newComment || !newComment.trim()">
          Post Comment
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
  import UserAvatar from '@Share/components/UserAvatar.vue';
  import { mapGetters } from 'vuex';

  export default {
    components: {
      UserAvatar,
    },
    props: {
      comment: {
        type: Object,
        default: () => null,
      },
      user: {
        type: Object,
        default: () => null,
      },
    },
    data() {
      return {
        newComment: '',
      };
    },
    computed: {
      ...mapGetters('USER', {
        users: 'GET_ENTRIES',
      }),
      ...mapGetters('TASK_COMMENTS', {
        updateLoading: 'GET_UPDATE_LOADING',
      }),
    },
    methods: {
      postComment() {
        if (!this.newComment || !this.newComment.trim()) return;
        this.$emit('post-comment', this.newComment);
      },
      mentionItems(text) {
        let items = this.users.map((e) => ({
          text: `${e.firstName} ${e.lastName}`,
          value: e.id,
          avatar: e.avatarUrl,
        }));
        if (text) {
          let filteredItems = items.filter((elem) => elem.text.toLowerCase().includes(text));
          return filteredItems;
        } else {
          return items;
        }
      },
    },
    mounted() {
      // Focus the editor after Vue updates the DOM
      this.$nextTick(() => {
        const editor = this.$el.querySelector('.editable .ProseMirror');
        if (editor) {
          editor.focus();
        }
      });
    },
    destroyed() {},
    watch: {},
  };
</script>

<style lang="scss">
  .commentBox {
    .gap-2 {
      gap: 8px;
    }
    
    .tiptap-section-card.editable header {
      background-color: var(--v-bg8-base) !important;
    }
    
    .v-tiptap.tiptap-section-card.editable {
      padding: 0;
    }
    
    .tiptap.ProseMirror {
      padding: 8px 12px !important;
    }
  }

  .v-menu__content:has(.v-tiptap-mentions) {
    z-index: 2000 !important;
  }
  
  .tiptap-section-card {
    width: 100%;
    max-height: 200px; // Slightly larger for adding comments
    overflow-y: auto;
    
    &.editable {
      border: 1px solid var(--v-primary-base);
      border-radius: 4px;
      padding: 8px;
    }
  }
  
  .tiptap-section-card .v-input__slot .v-card {
    border: none !important;
    border-radius: 0px;
    background-color: transparent;
    
    .ProseMirror {
      min-height: 60px !important;
      padding: 0px;
      pointer-events: auto;
      user-select: auto;
      cursor: text;
    }
  }
  
  .add-comment-mode {
    width: 100%;
    
    .gap-2 {
      gap: 8px;
    }
  }

  .mention {
    color: #08c;
    text-decoration: underline;
    cursor: pointer;
  }
  
  .v-tiptap-mentions .v-list-item:hover {
    background-color: var(--v-primary-base) !important;
  }
  
  .v-tiptap-mentions .v-list-item {
    background-color: var(--v-light-grey-darken1) !important;
  }
</style>
